import { Injectable } from '@angular/core';
import { AppService, Browser } from '../services/app.service';
import { PlusVoice, SimplePlusVoicesService } from '../services/voices-plus-simple.service';

const _u = "https://wwwnaturalreaderscom.s3.amazonaws.com/pw-portraits/";

let allVoices = null;
@Injectable({
  providedIn: 'root'
})
export class VoiceLoadService {
  private allLanguage = [];
  private curLanguage = null;
  private curList = null;
  private audioEle = null;
  private curFirst = 0;
  private playingID = null;
  private _selectedVoice: string;
  private _selectedVoiceSource: string;

  constructor(private simplePlusVoicesService: SimplePlusVoicesService) {
    console.log("VoiceLoadService")
    this.simplePlusVoicesService.setVoices()
      .then(() => {
        allVoices = Object.values(Object.assign({}, this.mapToObject(this.simplePlusVoicesService.getVoices()))).reduce(function (pre: PlusVoice, current: PlusVoice) {
          if (current['isLegacy']) {
            pre['Legacy'] = pre['Legacy'] || [];
            pre['Legacy'].push(current);
          } else {
            pre[current.languageName] = pre[current.languageName] || [];
            pre[current.languageName].push(current);
          }
          return pre;
        }, {});
        console.log("all voices", allVoices);
      })
  }

  setupVoices() {
    let allLanguage = Object.keys(allVoices).sort(function (a: string, b: string) {
      if (a.includes('Multi-Lingual') && !b.includes('Multi-Lingual')) {
        return -1;
      } else if (!a.includes('Multi-Lingual') && b.includes('Multi-Lingual')) {
        return 1;
      } else if (a.includes('English') && !b.includes('English')) {
        return -1;
      } else if (!a.includes('English') && b.includes('English')) {
        return 1;
      } else if (a.includes('English') && b.includes('English')) {
        let locales = ['US', 'UK', 'Australia', 'India', 'Nigeria', 'Wales'];

        let aMatchArray = a.match(/\(([^)]+)\)/);
        let bMatchArray = b.match(/\(([^)]+)\)/);
        if ((aMatchArray == null || aMatchArray.length < 2) && (bMatchArray == null || bMatchArray.length < 2)) {
          return 0;
        }
        if (aMatchArray == null || aMatchArray.length < 2) {
          return -1;
        }
        if (bMatchArray == null || bMatchArray.length < 2) {
          return 1;
        }

        let aLocale = aMatchArray[1];
        let bLocale = bMatchArray[1];
        if (aLocale == bLocale) {
          return 0;
        }
        let aIndex = locales.indexOf(aLocale);
        let bIndex = locales.indexOf(bLocale);
        if (aIndex == -1 || bIndex == -1) {
          return 1;
        }
        return (aIndex < bIndex) ? -1 : (aIndex > bIndex) ? 1 : 0;
      } else {
        return (a < b) ? -1 : (a > b) ? 1 : 0;
      }
    });
    console.log("allLanguage", allLanguage[0]);
    const pw_languages = document.getElementById("pw_languages") as HTMLSelectElement;
    let _self = this;
    // Clear existing options
    pw_languages.innerHTML = '';

    // Create optgroup for popular languages
    const popularOptgroup = document.createElement("optgroup");
    popularOptgroup.label = "Popular Languages";
    pw_languages.appendChild(popularOptgroup);

    // Add popular languages
    this.simplePlusVoicesService.popularLanguages.forEach(language => {
      const opt = document.createElement("option") as HTMLOptionElement;
      opt.value = language;
      opt.innerText = language === 'Multi-Lingual' ? 'Multi-lingual (Auto-detect)' : language;
      popularOptgroup.appendChild(opt);
    });

    // Create optgroup for other languages
    const otherOptgroup = document.createElement("optgroup");
    otherOptgroup.label = "Other Languages";
    pw_languages.appendChild(otherOptgroup);

    // Add other languages
    allLanguage.splice(allLanguage.indexOf('Legacy'), 1);
    allLanguage.splice(allLanguage.indexOf('Arabic'), 1);
    allLanguage.push('Legacy');
    allLanguage.forEach(language => {
      if (!this.simplePlusVoicesService.popularLanguages.includes(language)) {
        const opt = document.createElement("option") as HTMLOptionElement;
        opt.value = language;
        opt.innerText = language;
        otherOptgroup.appendChild(opt);
      }
    });

    pw_languages.addEventListener("change", function () {
      _self.curLanguage = this.value;
      _self.curList = allVoices[_self.curLanguage];
      _self.curFirst = 0;
      const audioEle = document.getElementById("pw-voice-preview") as HTMLAudioElement;
      audioEle.pause();

      const firstVoice = _self.curList[_self.curFirst]
      _self.selectedVoice = firstVoice.key;
      console.log("selectedVoice", _self.selectedVoice);
      _self.selectedVoiceSource = firstVoice.source;
      _self.playingID = null;
      _self.createPlayList(_self.curList);
    });

    let browserLang = this.getLanguageName2(navigator.language);
    console.log("browserLang", browserLang);
    if(browserLang === 'English (Canada)'){
      browserLang = 'English (US)';
    }
    if (allLanguage.includes(browserLang)) {
      this.curLanguage = browserLang;
      pw_languages.value = this.curLanguage;
    } else {
      let langWithoutLocale = browserLang.split(" (")[0];
      for (let i = 0; i < allLanguage.length; i++) {
        if (allLanguage[i].includes(langWithoutLocale)) {
          this.curLanguage = allLanguage[i];
          break;
        }
      }
      this.curLanguage = allLanguage[0];
    }

    this.curList = allVoices[this.curLanguage];
    this.createPlayList(this.curList);

    const prevBtn = document.getElementById('voice-prev');
    prevBtn.addEventListener("click", function () {
      if (_self.curFirst > 0) {
        _self.curFirst -= 4;
        if (_self.curFirst < 0) {
          _self.curFirst = 0;
        }
        const id = 'v_' + _self.curList[_self.curFirst].id + '_' + _self.curList[_self.curFirst].source;
        document.getElementById(id).scrollIntoView({
          inline: 'start',
          block: 'nearest',
          behavior: 'smooth'
        });
      }
    });
    const nextBtn = document.getElementById('voice-next');
    nextBtn.addEventListener("click", function () {
      if (_self.curFirst <= (_self.curList.length - 4)) {
        _self.curFirst += 4;
        if (_self.curFirst >= _self.curList.length) {
          _self.curFirst = _self.curList.length - 1;
        }
        const id = 'v_' + _self.curList[_self.curFirst].id + '_' + _self.curList[_self.curFirst].source;
        document.getElementById(id).scrollIntoView({
          inline: 'start',
          block: 'nearest',
          behavior: 'smooth'
        });
      }
    });
  }

  public mapToObject(map: Map<any, any>) {
    let obj = {};
    Array.from(map.keys()).forEach(key => {
      obj[key] = map.get(key);
    });
    return obj;
  }

  // group Chinese of different regions into Chinese
  getLanguageName2(lang) {
    let languageName = this.simplePlusVoicesService.voiceUtilService.getLanguageName(lang);
    if (languageName.includes('Chinese')) {
      languageName = 'Chinese';
    }
    return languageName;
  }

  createPlayList(voices) {
    const menu = document.getElementById("pw-free-list");
    menu.innerHTML = '';
    // for (let index = 0; index < voices.length; index++) {
    //   const element = voices[index];

    //   const opt = document.createElement("button");
    //   opt.classList.add("pw-voice-item");
      // opt.ariaLabel = "voice for " + this.curLanguage + ' - ' + element.name;
      // opt.id = 'v_' + element.id + '_' + element.source;

    //   const icon = document.createElement("div");
    //   icon.classList.add("voice-icon");

      // const jpg = element.icon;
      // if (!(AppService.isPW() && (AppService.appBrowser == Browser.iosBrowser || AppService.appBrowser == Browser.androidBrowser))) {
      //   const img = document.createElement("img");
      //   img.src = jpg;
      //   img.alt = "voice icon for " + this.curLanguage + ' - ' + element.name;
      //   icon.appendChild(img);
      // }

    //   const name = document.createElement("div");
    //   name.classList.add("voice-name");
    //   name.innerText = element.name;
    //   if (element.displayLocale && element.localeName) {
    //     name.innerText += ' (' + element.localeName + ')';
    //   }
    //   icon.appendChild(name);

    //   opt.appendChild(icon);

    //   if (element.desc) {
    //     const textLbl = document.createElement("div");
    //     textLbl.classList.add("voice-desc");
    //     let strArr = element.desc.split("for");
    //     let text1 = '';
    //     let text2 = '';
    //     if (strArr.length == 1) {
    //       text1 = '';
    //       text2 = element.desc;
    //     } else {
    //       text1 = strArr[0] + "for:";
    //       text2 = strArr[1];
    //     }

    //     const descLbl1 = document.createElement("div");
    //     descLbl1.innerText = text1;
    //     const descLbl2 = document.createElement("div");
    //     descLbl2.innerText = text2;

    //     textLbl.appendChild(descLbl1);
    //     textLbl.appendChild(descLbl2);
    //     opt.appendChild(textLbl);
    //   }

    //   const wave = document.createElement("div");
    //   wave.classList.add('voice-wave');
    //   opt.appendChild(wave);

      // let _self = this;
      // opt.addEventListener("click", function () {
      //   _self.setupAudio(element, opt);
      // });

    //   menu.appendChild(opt);
    // }

    for (let index = 0; index < voices.length; index++) {
      const element = voices[index];
      const voiceDiv = document.createElement("BUTTON");
      voiceDiv.classList.add("nr-btn", "nr-voice-card");
      voiceDiv.ariaLabel = "voice for " + this.curLanguage + ' - ' + element.name;
      voiceDiv.id = 'v_' + element.id + '_' + element.source;

      const iconBox = document.createElement("DIV");
      iconBox.classList.add("nr-voice-icon");
      
      const jpg = element.icon;
      const icon = document.createElement("img");
      // icon.classList.add("nr-voice-icon");
      icon.src = jpg;
      icon.alt = "voice icon for " + this.curLanguage + ' - ' + element.name;
      iconBox.appendChild(icon);

      const iconFlag = document.createElement("DIV");
      iconFlag.classList.add("nr-voice-flag");
      iconFlag.innerHTML = `<svg class="nr-voice-play"><use xlink:href="#nr_LLM_play"></use></svg>
                          <svg class="nr-voice-pause"><use xlink:href="#nr_LLM_pause"></use></svg>`;
      iconBox.appendChild(iconFlag);
      voiceDiv.appendChild(iconBox);

      const infoDiv = document.createElement("DIV");
      infoDiv.classList.add("nr-voice-info");

      const detailDiv = document.createElement("DIV");
      detailDiv.classList.add("nr-voice-detail");

      const nameDiv = document.createElement("DIV");
      nameDiv.classList.add("nr-voice-name");
      nameDiv.innerText = element.name;
      if (element.displayLocale && element.localeName) {
        nameDiv.innerText += ' (' + element.localeName + ')';
      }
      detailDiv.appendChild(nameDiv);

      const tagDiv = document.createElement("DIV");
      tagDiv.classList.add("nr-voice-tag");
      tagDiv.innerText = element.tags.join(", ");
      detailDiv.appendChild(tagDiv);

      infoDiv.appendChild(detailDiv);
      
      const waveDiv = document.createElement("DIV");
      waveDiv.classList.add("nr-voice-wave");
      waveDiv.innerHTML = `<svg class="nr-play-wave show-light"><use xlink:href="#pw_load_wave_d"></use></svg><svg class="nr-play-wave show-dark"><use xlink:href="#pw_load_wave"></use></svg>`;
      infoDiv.appendChild(waveDiv);
      voiceDiv.appendChild(infoDiv);
      
      let _self = this;
      voiceDiv.addEventListener("click", function () {
        _self.setupAudio(element, voiceDiv);
      });

      menu.appendChild(voiceDiv);
    }

    const width = document.body.clientWidth;
    if (width > 767) {
      this.curFirst = 0;
      const id = 'v_' + this.curList[0].id + '_' + this.curList[0].source;
      console.log("id", id);
      document.getElementById(id).scrollIntoView({
        inline: 'start',
        block: 'nearest',
        behavior: 'smooth'
      });
    }

  }

  setupAudio(voice, opt) {
    const audioEle = document.getElementById("pw-voice-preview") as HTMLAudioElement;
    this.selectedVoice = voice.key;
    console.log("setupAudio", this.selectedVoice);
    this.selectedVoiceSource = voice.source;
    if (opt.id != this.playingID) {
      if (this.playingID != null) {
        const playEle = document.getElementById(this.playingID);
        playEle.classList.remove("playing");
        playEle.classList.remove('ended');
        // const wave = playEle.querySelector(".voice-wave");
        // wave.innerHTML = '';
      }

      // const wavenew = opt.querySelector(".voice-wave");
      // wavenew.innerHTML = '<svg> <use xlink:href="#pw_load_wave"></use> </svg>';
      audioEle.src = this.simplePlusVoicesService.formPlusVoiceUrl(voice);
      audioEle.play();
      opt.classList.add("playing");
      this.playingID = opt.id;
    } else {
      if (audioEle.paused) {
        const playEle = document.getElementById(this.playingID);
        playEle.classList.remove("playing");
        playEle.classList.remove('ended');
        audioEle.play();
        opt.classList.add("playing");
        this.playingID = opt.id
      } else {
        audioEle.pause();
        opt.classList.remove("playing");
      }
    }
    const len = this.curList.length - 1;
    const end_id = 'v_' + this.curList[len].id + '_' + this.curList[len].source;
    if (this.playingID == end_id) {
      document.getElementById(end_id).scrollIntoView({
        inline: 'end',
        block: 'nearest',
        behavior: 'smooth'
      });
    }
    let _self = this;
    audioEle.addEventListener("ended", () => {
      const playEle = document.getElementById(_self.playingID);
      playEle.classList.remove("playing");
      playEle.classList.add("ended");
      this.playingID = null;
    });
  }

  set selectedVoice(val: string) {
    this._selectedVoice = val;
  }

  get selectedVoice(): string {
    return this._selectedVoice;
  }
  set selectedVoiceSource(val: string) {
    this._selectedVoiceSource = val;
  }
  get selectedVoiceSource(): string {
    return this._selectedVoiceSource;
  }

  stopPlayingAudio() {
    if (this.playingID != null) {
      const playEle = document.getElementById(this.playingID);
      playEle.classList.remove("playing");
      playEle.classList.remove('ended');
      const wave = playEle.querySelector(".nr-voice-wave");
      wave.innerHTML = '';
    }

    const audioEle = document.getElementById("pw-voice-preview") as HTMLAudioElement;
    if (audioEle) {
      audioEle.pause();
      audioEle.src = '';
    }
  }

  public write(key: string, value: any) {
    try {
      if (value) {
        value = JSON.stringify(value);
      }
      localStorage.setItem(key, value);
    } catch (e) {
      console.log('write error ', e)
    }
  }
}
